var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSilverPodiumWithNumber = function SvgSilverPodiumWithNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 68,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BFDEF0",
    d: "M0 4a4 4 0 0 1 4-4h95v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4435C",
    d: "M0 16h99v52H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.846 55.04c.256-3.456 1.984-8.416 6.816-10.4 2.816-1.248 5.663-2.112 5.663-4.416 0-2.336-2.272-3.488-4-3.488-2.464 0-4.736.928-5.12 3.264l-3.712-.384c.608-4.16 4.544-6.432 8.832-6.432 3.84 0 7.776 2.496 7.776 6.848 0 4.448-3.52 6.048-7.968 7.776-1.888.8-3.04 2.496-3.712 4.448H58.39v3.712H41.847z"
  })));
};
export default SvgSilverPodiumWithNumber;